import React, { useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import RegularButton from "components/CustomButtons/Button";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { getSurvey } from "redux/actions/surveys/surveysAction";
import { surveyStyles } from "./styles";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { animations } from "helpers/animations";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { GlobalBox } from "components/Box/GlobalBox";
import { validateObject } from "helpers/validateObject";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

export const SurveyQuestions = ({ hideBackBtn = false, onClose }) => {
  const { id } = useParams();

  const { survey, idStation } = useSelector(({ surveys }) => surveys);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const dispatch = useDispatch();

  useEffect(() => {
    id && dispatch(getSurvey(id));
  }, [id]);

  const filterColor = (data = "") => {
    const lower = data.toLowerCase();
    switch (lower) {
      case "si":
        return "#4caf50";
      case "bien":
        return "#4caf50";
      case "no":
        return "#f6685e";
      case "mal":
        return "#f6685e";
      default:
        return "";
    }
  };
  const classes = surveyStyles();
  const hist = useHistory();
  const handleNav = () => {
    hist.push("/admin/surveys");
  };

  return (
    <GlobalBox icon={<QuestionAnswerIcon />} className={animations.fadeIn}>
      <Box
        style={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography>Empleado: {survey?.employee?.name}</Typography>
          <Typography>Fecha: {survey?.date}</Typography>
          <Typography>Planta: {idStation?.label}</Typography>
          <Typography>Unidad: {survey?.unit}</Typography>
        </Box>
        {!hideBackBtn && (
          <RegularButton round justIcon onClick={handleNav} color="info">
            <ArrowBackIosIcon
              style={{ margin: 0, padding: 0, marginLeft: 7 }}
            />
          </RegularButton>
        )}
      </Box>
      <Grid container spacing={1} style={{ marginTop: 10 }}>
        {isLoadingComp?.loadingSurvey && validateObject(survey) ? (
          <LoadingComponent />
        ) : (
          survey?.questionGroups?.map((group) => (
            <Grid
              item
              xs={12}
              key={group.group}
              style={{ position: "relative", margin: "0 auto" }}
            >
              <Accordion className={`${classes.border} `}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className={classes.icon} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={`${classes.box} ${classes[group.bgColor]}`}
                >
                  <Typography className={classes.heading}>
                    {group.group}
                  </Typography>
                  <Box className={classes.text}>
                    <Box className={classes.text}>
                      <Typography className={classes.heading}>
                        {group.positive}
                      </Typography>
                      <CheckCircleIcon className={classes.iconG} />
                    </Box>
                    <Box className={classes.text}>
                      <CancelIcon className={classes.iconB} />
                      <Typography className={classes.heading}>
                        {group.negative}
                      </Typography>
                    </Box>
                  </Box>
                </AccordionSummary>
                {group.questions.map((question, idx) => {
                  return (
                    <AccordionDetails
                      className={classes.text}
                      key={question.idQuestion}
                    >
                      <Typography style={{ fontWeight: 700 }}>
                        {idx + 1})- Pregunta:{" "}
                        <span style={{ fontWeight: 400 }}>
                          {question.question}
                        </span>
                      </Typography>
                      {question.answer.length > 0 ? (
                        <Typography style={{ fontWeight: 700 }}>
                          Respuesta:{" "}
                          <span
                            style={{
                              fontWeight: 400,
                              color: filterColor(question.answer),
                            }}
                          >
                            {question.answer}
                          </span>
                        </Typography>
                      ) : (
                        <Typography>Sin comentarios</Typography>
                      )}
                    </AccordionDetails>
                  );
                })}
              </Accordion>
            </Grid>
          ))
        )}
      </Grid>
      {hideBackBtn && (
        <RegularButton color="info" onClick={onClose} style={{
          float: 'right'
        }}>
          aceptar
        </RegularButton>
      )}
    </GlobalBox>
  );
};
